import { urls } from '../constants/app';
import request from './utils/request';
import moment from 'moment';
import { setError, resetError } from './errors';

export function fetchDeliveryPoints() {
    return (dispatch, getState) => {
        dispatch({ type: 'SET_LOADER', field: 'deliveryMap', value: true });
        dispatch(resetError('deliveryMap'));

        const { filters } = getState().deliveryMap;
        const params = {};

        if (filters.createdStartDate) {
            params['created_at_gte'] = moment(filters.createdStartDate).subtract({ hours: 3 }).format('YYYY-MM-DD HH:mm:ss');
        }

        if (filters.createdEndDate) {
            params['created_at_lte'] = moment(filters.createdEndDate).subtract({ hours: 3 }).format('YYYY-MM-DD HH:mm:ss');
        }

        if (filters.points && filters.points.length) {
            params['points'] = filters.points.map((item) => item.value);
        }

        return request({ method: 'get', url: urls.statistics + '/deliveryPoints', params })
            .then((data) => {
                dispatch({
                    type: 'SET_DELIVERY_POINTS',
                    points: (data && data.points) || [],
                    summary: (data && data.summary) || { count: 0, revenue: 0 },
                    branches: (data && data.branches) || []
                });
                dispatch({ type: 'SET_LOADER', field: 'deliveryMap', value: false });
            })
            .catch((error) => {
                dispatch(setError(error, 'deliveryMap'));
                dispatch({ type: 'SET_LOADER', field: 'deliveryMap', value: false });
            });
    };
}

const isActualZone = (zone) => {
    if (!zone || zone.activate === 'disabled' || !zone.place) return false;
    return !(zone.point && typeof zone.point === 'object' && zone.point.hiddenClient === true);
};

export function fetchDeliveryZones(filtersOverride = null) {
    return (dispatch, getState) => {
        dispatch({ type: 'SET_LOADER', field: 'deliveryZones', value: true });

        const activeFilters = filtersOverride || getState().deliveryMap.filters;
        const params = { _limit: -1 };

        if (activeFilters.points && activeFilters.points.length) {
            params['point.id_in'] = activeFilters.points.map((item) => item.value);
        }

        return request({ method: 'get', url: `${urls.zone}/crm`, params })
            .then((data) => {
                dispatch({
                    type: 'SET_DELIVERY_ZONES',
                    zones: (Array.isArray(data) ? data : []).filter(isActualZone)
                });
                dispatch({ type: 'SET_LOADER', field: 'deliveryZones', value: false });
            })
            .catch((error) => {
                dispatch(setError(error, 'deliveryMap'));
                dispatch({ type: 'SET_DELIVERY_ZONES', zones: [] });
                dispatch({ type: 'SET_LOADER', field: 'deliveryZones', value: false });
            });
    };
}

export function setDeliveryShowZones(showZones) {
    return (dispatch) => {
        dispatch({ type: 'SET_DELIVERY_SHOW_ZONES', showZones });
    };
}

export function setDeliveryFilters(filters) {
    return (dispatch) => {
        dispatch({ type: 'SET_DELIVERY_FILTERS', filters });
    };
}

export function setDeliveryCellSize(cellSize) {
    return (dispatch) => {
        dispatch({ type: 'SET_DELIVERY_CELL_SIZE', cellSize });
    };
}

export function setDeliveryMetric(metric) {
    return (dispatch) => {
        dispatch({ type: 'SET_DELIVERY_METRIC', metric });
    };
}
